import { Ear, Lightbulb, Compass } from "lucide-react";
import { Reveal, Overline } from "./primitives";

const BLOCKS = [
  {
    icon: Ear,
    title: "Ascolto",
    text: "Uno spazio privato dove raccontare la tua situazione senza giudizio.",
  },
  {
    icon: Lightbulb,
    title: "Chiarezza",
    text: "Un confronto per comprendere meglio blocchi, pesi interiori e battaglie presenti.",
  },
  {
    icon: Compass,
    title: "Direzione",
    text: "Un primo orientamento concreto su come iniziare a muoverti.",
  },
];

export const WhatIsMapSection = () => (
  <section id="la-mappa" className="relative bg-white/[0.02] py-28 sm:py-36" data-testid="whatismap-section">
    <div className="mx-auto max-w-6xl px-6 sm:px-8">
      <Reveal className="max-w-3xl">
        <Overline>Il primo passo</Overline>
        <h2 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-6xl font-medium leading-[1.02] tracking-tight text-white">
          Che cos'è la <span className="italic text-gold">Mappa del Tempio?</span>
        </h2>
      </Reveal>

      <Reveal delay={0.12}>
        <div className="mt-10 max-w-3xl space-y-5 text-base sm:text-lg font-light leading-relaxed text-white/75">
          <p>
            La Mappa del Tempio è un incontro{" "}
            <span className="text-white">privato, gratuito, di 30 minuti</span>, pensato per
            offrirti uno spazio reale di ascolto e confronto.
          </p>
          <p>
            Non è una semplice call informativa. È un momento dedicato a te, alla tua situazione e
            alla battaglia che stai attraversando oggi.
          </p>
          <p>
            Potrai aprirti su ciò che stai vivendo nelle aree della{" "}
            <span className="text-gold">
              fede, della mente, del corpo, delle emozioni, delle relazioni, delle dipendenze o
              dello scopo
            </span>
            .
          </p>
          <p className="font-serif text-xl sm:text-2xl italic text-white">
            Il nostro approccio considera la persona nella sua interezza, con Dio al centro.
          </p>
        </div>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-3" data-testid="mappa-blocks">
        {BLOCKS.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.1}>
            <div className="h-full rounded-2xl border border-white/15 bg-white/[0.03] p-8 transition-colors duration-300 hover:border-gold/50">
              <b.icon className="h-6 w-6 text-gold" />
              <p className="mt-6 font-serif text-xl sm:text-2xl font-medium uppercase tracking-wide text-white">
                {b.title}
              </p>
              <p className="mt-3 text-sm sm:text-base font-light leading-relaxed text-white/70">
                {b.text}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
